import { render, staticRenderFns } from "./ClassTabPupils.vue?vue&type=template&id=f1d29576&scoped=true&"
import script from "./ClassTabPupils.vue?vue&type=script&lang=js&"
export * from "./ClassTabPupils.vue?vue&type=script&lang=js&"
import style0 from "./ClassTabPupils.vue?vue&type=style&index=0&id=f1d29576&prod&lang=scss&scoped=true&"
import style1 from "./ClassTabPupils.vue?vue&type=style&index=1&id=f1d29576&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d29576",
  null
  
)

export default component.exports